export default {
  savingsGoal: {
    title: 'Savings goal',
    default: 6000,
    min: 1,
    max: 10000000,
    error: 'Please enter a value between 1 and 10000000.'
  },
  yearsToSave: {
    title: 'Years to reach goal',
    default: 2,
    min: 0.083,
    max: 40,
    error: 'Please enter a value between 0.083 and 40.'
  },
  interestRate: {
    title: 'Interest rate per year',
    default: 5,
    min: 0.0001,
    max: 99,
    error: 'Please enter a value between 0 and 99.'
  },
  compoundingOption: {
    title: 'Compounding Method',
    default: 'daily'
  },
  firstDeposit: {
    title: 'Amount of first deposit',
    default: 100,
    min: 1,
    error: 'Please enter a value between 1 and your savings goal.'
  },
  skip2WeeksOption: {
    // @todo - remove once we definitely know not required
    title: 'Stop saving for two weeks each year?',
    default: 'no'
  },
  startDate: {
    title: 'Date of first deposit',
    default: new Date()
  }
}
